module.exports = __webpack_public_path__ + "static/media/bg@2x.6868b23b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/bg@2x.png
// module id = 801
// module chunks = 0